export const WONINGEN_COLLECTION = 'woningen';
export const PROJECTS_COLLECTION = 'tiltprojecten';
export const MEETPUNTEN_COLLECTION = 'tiltmeetpunten';
export const SENSOREN_COLLECTION = 'tiltsensoren';
export const ALARM_WAARDEN = 'tiltalarmen';
export const GEBRUIKERS_COLLECTION = 'tiltgebruikers';
export const DASHBOARD_COLLECTION = 'tiltalarmdashboard';
export const DASHBOARD__SETTINGS_COLLECTION = 'dashboardsettings';
